export default "__VITE_ASSET__PYR6XrJt__"